import { render, staticRenderFns } from "./StyledRefinementList.vue?vue&type=template&id=6e39c859&scoped=true&"
import script from "./StyledRefinementList.vue?vue&type=script&lang=js&"
export * from "./StyledRefinementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e39c859",
  null
  
)

export default component.exports